import { ICommand } from 'core-ts-types';
import { PathTask } from '../builders/path_task_builder';
import * as _4 from 'lodash4';

export class TaskUpdateFunction {
  constructor(
    private updateTaskStatusAndModelsCommand: ICommand,
    private TaskStatusEnum: any,
    private EventCategoryEnum: any
  ) {}

  getNewStatusAsString(task: PathTask, initialStatus: string, isDismissed: boolean): string {
    const status = initialStatus || this.TaskStatusEnum.get(task.status).key;
    let updateToString;

    // Return original status if task is autocompletable
    if (this.isAutoCompletable(task)) {
      return status;
    }

    if (isDismissed && !this.TaskStatusEnum.isCompleted(status)) {
      updateToString = this.getStatusString(status, 'DISMISSED');
    } else if (!isDismissed && !this.TaskStatusEnum.isDismissed(status)) {
      updateToString = this.getStatusString(status, 'COMPLETED');
    } else if (!isDismissed && this.TaskStatusEnum.isDismissed(status)) {
      updateToString = this.TaskStatusEnum.get('ACTIVE').key;
    }

    return updateToString;
  }

  private getStatusString(status: string, statusVal: string): string {
    return this.TaskStatusEnum.isActive(status)
      ? this.TaskStatusEnum.get(statusVal).key
      : this.TaskStatusEnum.get('ACTIVE').key;
  }

  toggleStatus(task: PathTask, status: string, isAutoComplete: boolean) {
    isAutoComplete = !!isAutoComplete;

    return this.updateTaskStatusAndModelsCommand(status, task, isAutoComplete).then((updatedTask) => {
      updatedTask.status_changed_ts = moment();
      return updatedTask;
    });
  }

  toggleDismissed(task: PathTask, initialStatus: string, isAutoComplete: boolean) {
    return this.toggleStatus(task, this.getNewStatusAsString(task, initialStatus, true), isAutoComplete);
  }

  toggleComplete(task: PathTask, initialStatus: string, isAutoComplete: boolean) {
    return this.toggleStatus(task, this.getNewStatusAsString(task, initialStatus, false), isAutoComplete);
  }

  isActive(task: PathTask) {
    const status = this.TaskStatusEnum.get(task.status);
    return this.TaskStatusEnum.isActive(status);
  }

  isCompleted(task: PathTask) {
    if (this.isStaffDrivenToDo(task)) {
      return !_4.isEmpty(_4.get(task, 'cleared_date'));
    }
    const status = this.TaskStatusEnum.get(task.status);
    return this.TaskStatusEnum.isCompleted(status);
  }

  isOverdue(task: PathTask) {
    if (this.isStaffDrivenToDo(task)) {
      return !this.isCompleted(task) && moment(_4.get(task, 'due_date') || '').isBefore(moment(), 'day');
    }
    if (this.isPersonalReminder(task)) {
      return false;
    }

    const status = this.TaskStatusEnum.get(task.status);
    const stillActive = task.end_ts.isBefore(moment());
    return this.TaskStatusEnum.isActive(status) && stillActive;
  }

  isDismissed(task: PathTask) {
    const status = this.TaskStatusEnum.get(task.status);
    return this.TaskStatusEnum.isDismissed(status);
  }

  isAutoCompletable(task: PathTask) {
    return (
      !this.isPersonalReminder(task) && !this.isStaffDrivenToDo(task) && !task.is_completable && !task.is_dismissible
    );
  }

  isPendingComplete(task: PathTask) {
    return !this.isCompleted(task) && this.isAutoCompletable(task) && !!task.is_pending_complete;
  }

  isDateMarker(task: PathTask) {
    return this.EventCategoryEnum.isDateMarker(task.category);
  }

  isPersonalReminder(task: PathTask) {
    return this.EventCategoryEnum.isPersonalReminder(task.category);
  }

  isStaffDrivenToDo(task: PathTask): boolean {
    return !_4.isEmpty(_4.get(task, 'created_by_name'));
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/functions/task_update_fn.ts